<template lang="html">
  <div style="position: relative;">
    <div class="size margin">
      <router-view class="animation-bottom animation-delay-01 padding-top-20"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpeakUp',
  mounted () {
    this.$store.commit('setSpeakUpFeedback', true)
  },
  beforeDestroy () {
    this.$store.commit('setSpeakUpFeedback', false)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/speakUpFeedback/index.vue